"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardProgram = exports.RewardsAccountType = void 0;
const web3_js_1 = require("@solana/web3.js");
const common_1 = require("@everlend/common");
var RewardsAccountType;
(function (RewardsAccountType) {
    RewardsAccountType[RewardsAccountType["Uninitialized"] = 0] = "Uninitialized";
    RewardsAccountType[RewardsAccountType["RewardsRoot"] = 1] = "RewardsRoot";
    RewardsAccountType[RewardsAccountType["RewardPool"] = 2] = "RewardPool";
})(RewardsAccountType = exports.RewardsAccountType || (exports.RewardsAccountType = {}));
class RewardProgram extends common_1.Program {
}
exports.RewardProgram = RewardProgram;
RewardProgram.PUBKEY = new web3_js_1.PublicKey('ELDR7M6m1ysPXks53T7da6zkhnhJV44twXLiAgTf2VpM');
//# sourceMappingURL=rewardProgram.js.map